import React from "react";
import {
	Grid,
	Card,
	CardContent,
	Typography,
	Box
} from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import DescriptionIcon from "@material-ui/icons/Description";
import PlaceIcon from "@material-ui/icons/Place";
import DraftsIcon from "@material-ui/icons/Drafts";
import PublicIcon from '@material-ui/icons/Public';
import PersonIcon from '@material-ui/icons/Person';

export default function DashboardSummary({ summary }) {
	if (!summary) return null;

	return (
		<Box mb={4}>
			<Grid container spacing={3}>

				{/* TOTAL EVENTS */}
				<Grid item xs={12} sm={6} md={3}  >
					<Card elevation={3}>
						<CardContent>
							<Box display="flex" alignItems="center">
								<EventIcon color="primary" style={{ fontSize: 40, marginRight: 16 }} />
								<div>
									<Typography variant="body2" color="textSecondary">
										เหตุการณ์ทั้งหมด
									</Typography>
									<Typography variant="h5">
										{summary.total_events}
									</Typography>
								</div>
							</Box>
						</CardContent>
					</Card>
				</Grid>

				{/* TOTAL REPORTS */}
				<Grid item xs={12} sm={6} md={3}>
					<Card elevation={3}>
						<CardContent>
							<Box display="flex" alignItems="center">
								<DescriptionIcon style={{ fontSize: 40, marginRight: 16 }} />
								<div>
									<Typography variant="body2" color="textSecondary">
										ชุดเอกสารทั้งหมด
									</Typography>
									<Typography variant="h5">
										{summary.total_reports}
									</Typography>
								</div>
							</Box>
						</CardContent>
					</Card>
				</Grid>

				{/* TOTAL AREAS */}
				<Grid item xs={12} sm={6} md={3}>
					<Card elevation={3}>
						<CardContent>
							<Box display="flex" alignItems="center">
								<PlaceIcon style={{ fontSize: 40, marginRight: 16 }} />
								<div>
									<Typography variant="body2" color="textSecondary">
										จังหวัดที่เกี่ยวข้อง
									</Typography>
									<Typography variant="h5">
										{summary.total_areas}
									</Typography>
								</div>
							</Box>
						</CardContent>
					</Card>
				</Grid>

				{/* STATUS */}
				<Grid item xs={12} sm={6} md={3}>
					<Card elevation={3}>
						<CardContent>
							<Typography variant="body2" color="textSecondary">
								สถานะเหตุการณ์
							</Typography>

							<Box display="flex" justifyContent="space-between" mt={1} flexWrap="wrap" style={{ gap: 12 }}>
								{/* Draft */}
								<Box display="flex" alignItems="center">
									<DraftsIcon style={{ marginRight: 6, color: "#f59e0b", fontSize: 20 }} />
									<Typography variant="body2">
										แบบร่าง: {summary.status.draft || 0}
									</Typography>
								</Box>

								{/* Public */}
								<Box display="flex" alignItems="center">
									<PublicIcon style={{ marginRight: 6, color: "#10b981", fontSize: 20 }} />
									<Typography variant="body2">
										สาธารณะ: {summary.status.public || 0}
									</Typography>
								</Box>

								{/* Internal */}
								<Box display="flex" alignItems="center">
									<PersonIcon style={{ marginRight: 6, color: "#3b82f6", fontSize: 20 }} />
									<Typography variant="body2">
										ภายใน: {summary.status.internal || 0}
									</Typography>
								</Box>
							</Box>

						</CardContent>
					</Card>
				</Grid>

			</Grid>
		</Box>
	);
}
